import React from 'react';
import { Box, Text } from '@wix/design-system';
import { Check, MinusSmall, X } from '@wix/wix-ui-icons-common/lazy';
import s from '../FeatureRow.scss';
export const FeatureRowValue = ({ text, isEnabled, classNames, dataHook, isDisabledInMonthly, }) => {
    const HasFeatureIndicator = () => {
        if (isEnabled && isDisabledInMonthly) {
            return (React.createElement(X, { className: [classNames?.x, s.xDisabledInMonthly]
                    .filter(Boolean)
                    .join(' ') }));
        }
        return isEnabled ? (React.createElement(Check, { className: classNames?.check })) : (React.createElement(MinusSmall, { className: classNames?.minus }));
    };
    return (React.createElement(Box, { textAlign: "center", className: classNames?.container, dataHook: dataHook }, text && !isDisabledInMonthly ? (React.createElement(Text, { size: "small", className: classNames?.text }, text)) : (React.createElement(HasFeatureIndicator, null))));
};
//# sourceMappingURL=FeatureRowValue.js.map